export default __webpack_public_path__ + "static/media/about-us-1056.b7cbcec4.jpg";